import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} - KeywordIP` : 'KeywordIP - SEO Intelligence Platform';
    
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
